import { TripContainer } from "./tripContainer";

export class Trip{
    id: number;
    clientId: number;
    client: string;
    billOfLading: string;
    containerQuantity: number;
    shippingLineId: number;
    shippingLine: string;
    tripStatus: string;
    totalRate: number;
    paymentStatus: string;
    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;
    isActive: boolean;
    tripContainers: TripContainer[];
    tripDateFinished: string;
    tripTypeId: number;

    //--for display purposes only
    showTripContainers?: boolean;
}

export interface ITripSearchResult {
    id: number;
    clientId: number;
    client: string;
    billOfLading: string;
    shippingLineId: number;
    shippingLine: string;
    tripDateFinished: string;
    totalRate: number;
    paymentDateFinished: string;
    tripStatus: string;
    paymentStatus: string;
    isActive: boolean;
    containerQuantity: number;
    tripTypeId: number;
    tripType: string;
    createdDate: string;
    createdBy: string;

    containers: ITripSearchResultContainer[];
}

export interface ITripSearchResultContainer {
    id: number;
    containerNumber: string;
    containerNumberTwo: string;
    containerSize: string;
    status: string;
    pickupPoint: string;
    destination: string;
    driverRate: number;

    dailyTripId: number | null;
    hasDailyTripTicketId: boolean;
    returnEmptyDailyTripId: number | null;
    hasReturnEmptyDailyTripTicketId: boolean;
}


// WEBPACK FOOTER //
// ./src/app/models/trips/trip.ts